<div class="container-fluid px-4 pb-4">
    <app-outbound-my-score-filter-bar
        title="Pre-Production Orders"
        (filtersChanged)="onFiltersChanged($event)"
    ></app-outbound-my-score-filter-bar>

    <app-doughnut-chart-table
        title="Pre-Production Orders"
        [slices]="slices"
        [palette]="palette"
        [score]="myScorePercent"
    ></app-doughnut-chart-table>

    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body">
            <div class="row g-3">
                @for (tile of summaryTiles; track tile.label) {
                    <div class="col-12 col-md-6 col-xl-4">
                        <div class="d-flex align-items-center p-2">
                            <div class="d-flex align-items-center justify-content-center flex-shrink-0 me-3 rounded-circle {{ tile.bg }}" style="width: 48px; height: 48px;">
                                <i class="{{ tile.icon }} fs-5 {{ tile.color }}"></i>
                            </div>
                            <div>
                                <div class="fs-4 mb-0">{{ tile.value | number }}</div>
                                <small class="fw-bold">{{ tile.label }}</small>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>

    <div class="card border-0 shadow-sm">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <h4 class="mb-0 text-secondary">My Score Trending</h4>
                <dx-select-box
                    [items]="groupingOptions"
                    [(value)]="grouping"
                    valueExpr="value"
                    displayExpr="text"
                    stylingMode="filled"
                    [width]="140"
                    (onValueChanged)="onGroupingChanged()"
                ></dx-select-box>
            </div>
            <dx-chart [dataSource]="trendingData">
                <dxi-series argumentField="period" valueField="released" name="Released to HDC" type="bar" [color]="releasedColor" [barPadding]="0.3"></dxi-series>
                <dxi-series argumentField="period" valueField="late" name="Late Released to HDC" type="line" [color]="lateColor"></dxi-series>
                <dxi-value-axis [visualRange]="{ startValue: 0, endValue: 100 }" [tickInterval]="20">
                    <dxo-label [customizeText]="percentAxisLabel"></dxo-label>
                </dxi-value-axis>
                <dxo-argument-axis argumentType="datetime">
                    <dxo-label [visible]="true"></dxo-label>
                    <dxo-grid [visible]="false"></dxo-grid>
                    <dxo-tick [visible]="false"></dxo-tick>
                </dxo-argument-axis>
                <dxo-legend [visible]="true" verticalAlignment="bottom" horizontalAlignment="center"></dxo-legend>
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTrendingTooltip"></dxo-tooltip>
            </dx-chart>
        </div>
    </div>
</div>
